var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-expansion-panels",
        { staticClass: "mt-6", attrs: { value: _vm.current_panel } },
        [
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [_vm._v(" General Settings ")]),
              _c(
                "v-expansion-panel-content",
                [
                  _vm.phoneSid
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: "Use custom settings",
                                  messages:
                                    "Turn this on to override the default settings with the ones below.",
                                },
                                model: {
                                  value:
                                    _vm.phone_numbers.phone_settings
                                      .use_custom_settings,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.phone_numbers.phone_settings,
                                      "use_custom_settings",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "phone_numbers.phone_settings.use_custom_settings",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Forwarding Phone Number",
                              outlined: "",
                              "hide-details": "",
                              placeholder: "+12223334444",
                            },
                            model: {
                              value:
                                _vm.phone_numbers.phone_settings
                                  .forwarding_phone_number,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.phone_numbers.phone_settings,
                                  "forwarding_phone_number",
                                  $$v
                                )
                              },
                              expression:
                                "phone_numbers.phone_settings.forwarding_phone_number",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-radio-group",
                            {
                              attrs: { row: "", dense: "", "hide-details": "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [_c("div", [_vm._v("Caller ID:")])]
                                  },
                                  proxy: true,
                                },
                              ]),
                              model: {
                                value:
                                  _vm.phone_numbers.phone_settings.caller_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.phone_numbers.phone_settings,
                                    "caller_id",
                                    $$v
                                  )
                                },
                                expression:
                                  "phone_numbers.phone_settings.caller_id",
                              },
                            },
                            [
                              _c("v-radio", {
                                attrs: { label: "Caller #", value: "caller" },
                              }),
                              _c("v-radio", {
                                attrs: { label: "Called #", value: "called" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-switch", {
                            attrs: {
                              label: "Forward SMS Messages",
                              "hide-details": "",
                              dense: "",
                            },
                            model: {
                              value:
                                _vm.phone_numbers.phone_settings
                                  .forward_sms_messages,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.phone_numbers.phone_settings,
                                  "forward_sms_messages",
                                  $$v
                                )
                              },
                              expression:
                                "phone_numbers.phone_settings.forward_sms_messages",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label: "Send Call Notification SMS",
                              "hide-details": "",
                              dense: "",
                            },
                            model: {
                              value:
                                _vm.phone_numbers.phone_settings
                                  .send_call_notification_sms,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.phone_numbers.phone_settings,
                                  "send_call_notification_sms",
                                  $$v
                                )
                              },
                              expression:
                                "phone_numbers.phone_settings.send_call_notification_sms",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label: "Press key to connect",
                              "hide-details": "",
                              dense: "",
                            },
                            model: {
                              value:
                                _vm.phone_numbers.phone_settings
                                  .press_key_to_connect,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.phone_numbers.phone_settings,
                                  "press_key_to_connect",
                                  $$v
                                )
                              },
                              expression:
                                "phone_numbers.phone_settings.press_key_to_connect",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-switch", {
                            attrs: {
                              label: "Whisper lead info",
                              "hide-details": "",
                              dense: "",
                            },
                            model: {
                              value:
                                _vm.phone_numbers.phone_settings
                                  .whisper_lead_info,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.phone_numbers.phone_settings,
                                  "whisper_lead_info",
                                  $$v
                                )
                              },
                              expression:
                                "phone_numbers.phone_settings.whisper_lead_info",
                            },
                          }),
                          _c("v-switch", {
                            attrs: {
                              label: "Record",
                              "hide-details": "",
                              dense: "",
                            },
                            model: {
                              value: _vm.phone_numbers.phone_settings.record,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.phone_numbers.phone_settings,
                                  "record",
                                  $$v
                                )
                              },
                              expression: "phone_numbers.phone_settings.record",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [_vm._v(" Advanced Settings ")]),
              _c(
                "v-expansion-panel-content",
                [
                  _c("p", [
                    _vm._v(
                      "If you prefer that another application handle your incoming calls or texts, you can enter the URLs below. This will cause all other settings above to have no effect."
                    ),
                  ]),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Redirect Incoming Calls to URL",
                              placeholder: "https://",
                              outlined: "",
                            },
                            model: {
                              value:
                                _vm.phone_numbers.phone_settings
                                  .voice_redirect_url,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.phone_numbers.phone_settings,
                                  "voice_redirect_url",
                                  $$v
                                )
                              },
                              expression:
                                "phone_numbers.phone_settings.voice_redirect_url",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Redirect Incoming SMS to URL",
                              placeholder: "https://",
                              outlined: "",
                            },
                            model: {
                              value:
                                _vm.phone_numbers.phone_settings
                                  .sms_redirect_url,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.phone_numbers.phone_settings,
                                  "sms_redirect_url",
                                  $$v
                                )
                              },
                              expression:
                                "phone_numbers.phone_settings.sms_redirect_url",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c(
            "v-btn",
            {
              staticClass: "mt-4",
              attrs: {
                color: "success",
                loading: _vm.phone_numbers.saving_phone_settings,
                disabled: _vm.phone_numbers.saving_phone_settings,
              },
              on: {
                click: function ($event) {
                  return _vm.phone_numbers.savePhoneSettings(_vm.phoneSid)
                },
              },
            },
            [_vm._v(" Save Phone Settings ")]
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: {
            value: _vm.phone_numbers.loading_phone_settings,
            absolute: true,
            opacity: "1",
            color: _vm.overlay_color,
          },
        },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "primary" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }